define('shared/util/dispatchers/publishers/state',[
    'shared/lib/RSVP', 
    'shared/util/state',
    'shared/util/state/adapters/form',
    'shared/util/state/adapters/order',
    'shared/util/state/adapters/persistent',
    'shared/util/state/adapters/user',
    'shared/util/state/adapters/tracking',
    'shared/util/state/adapters/pending',
    'shared/util/state/adapters/session'
], 
function(
    RSVP, 
    state,
    formAdapter, 
    orderAdapter, 
    persistentAdapter, 
    userAdapter,
    trackingAdapter,
    pendingAdapter,
    sessionAdapter
){
    'use strict';
    
    return function ( key, value ) {
        return new RSVP.Promise(function( resolve, reject ){
            RSVP.all([
                state.adapters.add(formAdapter),
                state.adapters.add(orderAdapter),
                state.adapters.add(persistentAdapter),
                state.adapters.add(userAdapter),
                state.adapters.add(trackingAdapter),
                state.adapters.add(pendingAdapter),
                state.adapters.add(sessionAdapter)
            ])
            .then(function(){
                return state
                    .push( key , value );
            })
            .then(resolve, reject);
        });
    };
});
